/**
 * Science page — Lens Colors display widget
 * Reuses shop-by-color data + display logic (no ATC / frame search / splash).
 */
(function () {
  'use strict';

  const root = document.getElementById('sci-colors');
  if (!root) return;

  const tierAvailability = {
    AMP: ['AMV26', 'B', 'BL', 'CBM', 'G', 'G15', 'GM', 'GR', 'NOV', 'ONG'],
    Pro: ['B', 'BL', 'CBM', 'G', 'G15', 'GM', 'GR', 'GRADB', 'GRADG', 'MNBL', 'NOV', 'ONG', 'PM', 'RG', 'SSM', 'YM'],
    Standard: ['B', 'BL', 'CAR', 'CBM', 'CLBL', 'G', 'G15', 'GM', 'GR', 'GRADB', 'GRADG', 'MNBL', 'NOV', 'ONG', 'PH', 'PM', 'RG', 'SSM', 'YAR', 'YM']
  };

  const state = {
    colorCode: 'BL',
    tier: 'Standard'
  };

  const resolveSpecData = (tierData, baseData) => {
    if (tierData && typeof tierData === 'object') return tierData;
    return baseData || null;
  };

  const buildSkuCode = (c, tier) => {
    const code = (c || '').toUpperCase();
    if (code === 'AMV26' || code === 'V26') return 'AMV26';
    if (tier === 'AMP') return `AM${code}P`;
    if (tier === 'Pro') return `ZS${code}P`;
    return code;
  };

  const formatLightLabel = (light) => {
    if (!light) return '--';
    return light
      .split(/[\s-]+/)
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const getLensData = () => {
    if (Array.isArray(window.lensColorsData)) return window.lensColorsData;
    const el = document.getElementById('lens-colors-data');
    if (!el) return [];
    try {
      const parsed = JSON.parse(el.textContent);
      window.lensColorsData = parsed;
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      console.error('[Science Lens Colors] Failed to parse lens data', err);
      return [];
    }
  };

  const $swatchList = root.querySelector('#product-swatches-list');
  const $tierButtons = Array.from(root.querySelectorAll('.tier-button[data-tier]'));

  const updateTierAvailability = (colorCode) => {
    $tierButtons.forEach((btn) => {
      const tier = btn.getAttribute('data-tier');
      const isAvailable = tierAvailability[tier] && tierAvailability[tier].includes(colorCode);
      btn.classList.toggle('tier-unavailable', !isAvailable);
      btn.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
    });

    const currentOk = tierAvailability[state.tier] && tierAvailability[state.tier].includes(colorCode);
    if (!currentOk) {
      const next = ['Standard', 'Pro', 'AMP'].find(
        (tier) => tierAvailability[tier] && tierAvailability[tier].includes(colorCode)
      );
      if (next) state.tier = next;
    }

    $tierButtons.forEach((btn) => {
      btn.classList.toggle('selected-tier', btn.getAttribute('data-tier') === state.tier);
    });
  };

  const render = () => {
    const lensData = getLensData();
    const colorKey = state.colorCode;
    const fullColorCode = buildSkuCode(colorKey, state.tier);
    const colorData = lensData.find((c) => c._key === colorKey);
    const tierColorData = lensData.find((c) => c._key === fullColorCode);
    const specDetails = resolveSpecData(tierColorData, colorData);

    updateTierAvailability(colorKey);

    if (!colorData) return;

    const colorName = root.querySelector('#sbc-color-name');
    if (colorName) {
      colorName.textContent = colorData.colorname || colorData['lens-view'] || colorData.name || 'Unknown';
    }

    const lensDescription = root.querySelector('#sbc-lens-description');
    if (lensDescription) {
      lensDescription.textContent = colorData['lens-color'] || specDetails?.['lens-color'] || '--';
    }

    const specsContainer = root.querySelector('.sbc-specs');
    if (specsContainer && colorData.primarycolor && colorData.secondarycolor) {
      specsContainer.style.setProperty('--primarycolor', colorData.primarycolor);
      specsContainer.style.setProperty('--secondarycolor', colorData.secondarycolor);
    }

    const brightness = root.querySelector('#sbc-spec-brightness');
    if (brightness) {
      brightness.textContent = specDetails && specDetails.vlt != null ? `${specDetails.vlt}%` : '--';
    }

    const view = root.querySelector('#sbc-spec-view');
    if (view) {
      view.textContent = specDetails?.['lens-view'] || '--';
    }

    const lightCondition = specDetails?.light;
    root.querySelectorAll('.sbc-vlt-icon').forEach((icon) => {
      icon.classList.toggle('active', icon.getAttribute('data-light') === lightCondition);
    });

    const vltLabelValue = root.querySelector('#sbc-vlt-label-value');
    if (vltLabelValue) {
      vltLabelValue.textContent = formatLightLabel(lightCondition);
    }

    const activitiesListEl = root.querySelector('#sbc-activities');
    if (activitiesListEl) {
      const activitiesSource =
        tierColorData && tierColorData.activities ? tierColorData.activities : colorData.activities;
      let activities = [];
      if (activitiesSource) {
        activities = activitiesSource
          .split(',')
          .map((activity) => activity.trim())
          .filter((activity) => activity.length > 0)
          .slice(0, 4)
          .map((activity) => activity.replace(/-/g, ' '));
      }
      activitiesListEl.innerHTML = '';
      if (!activities.length) {
        const placeholder = document.createElement('li');
        placeholder.textContent = '--';
        activitiesListEl.appendChild(placeholder);
      } else {
        activities.forEach((activity) => {
          const chip = document.createElement('li');
          chip.textContent = activity;
          activitiesListEl.appendChild(chip);
        });
      }
    }

    const primaryImg = root.querySelector('#sbc-primary-image');
    if (primaryImg) {
      primaryImg.src = `https://cdn.shopify.com/s/files/1/1542/2169/files/226-${colorKey.toLowerCase()}.jpg`;
      primaryImg.alt = colorData.colorname || colorData.name || 'Lens color';
    }
  };

  if ($swatchList) {
    $swatchList.addEventListener('click', (e) => {
      const a = e.target.closest('a');
      if (!a || !$swatchList.contains(a)) return;
      e.preventDefault();
      state.colorCode = a.id;
      $swatchList.querySelectorAll('a.active-thumb').forEach((x) => x.classList.remove('active-thumb'));
      a.classList.add('active-thumb');
      render();
    });
  }

  $tierButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('tier-unavailable')) return;
      state.tier = btn.getAttribute('data-tier');
      render();
    });
  });

  const boot = () => {
    const defaultSwatch = $swatchList && $swatchList.querySelector(`a#${state.colorCode}`);
    if (defaultSwatch) {
      $swatchList.querySelectorAll('a.active-thumb').forEach((x) => x.classList.remove('active-thumb'));
      defaultSwatch.classList.add('active-thumb');
    }
    render();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
